//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex'
import { Tab, TabItem } from '../Common/Tab'
import { Card, CardItem, CustomCard } from '../Common/Card'
import MatchEmpty from '../Common/MatchEmpty.vue'
import FilterOption from '../Common/FilterOption.vue'
import LoadingView from '../Common/LoadingView.vue'
import meiqia from '../../utils/meiqia'
import fixSafariOverflowScrolling from '../../utils/safari-fix'

export default {
  name: 'CustomList',
  components: {
    Card,
    CardItem,
    CustomCard,
    Tab,
    TabItem,
    MatchEmpty,
    FilterOption,
    LoadingView,
  },
  mounted() {
    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling')
    fixSafariOverflowScrolling(this, 'touch')
  },
  data() {
    return {
      placeholder: '加载中',
      offset: 44,
      showFilter: false,
      showFilterOption: false,
      optionType: '',
      options: [],
      current: null,
      selected: {
        time: {},
        category: {},
        city: {},
      },
      filter: {
        time: null,
        categoryId: null,
        cityId: null,
      },
      selectedOption: {},
      selectedType: '',
      routeCategories: [],
      showLoading: false,
    }
  },
  computed: {
    ...mapState({
      categories: ({ custom }) => custom.categories,
      filterInfo: ({ custom }) => custom.filterInfo,
      routeList: ({ custom }) => custom.routeList,
    }),
    customRouteType() {
      if (this.categories) {
        if (this.categories.find(category => category.categoryId === this.current)) {
          return this.categories.find(category => category.categoryId === this.current)
            .customRouteType
        }
      }
      return 0
    },
  },
  methods: {
    ...mapActions(['fetchCustomRouteCategoryList', 'fetchCustomRouteList', 'fetchCustomFilterInfo']),
    isEmpty() {
      if (this.routeList.length === 0) {
        this.placeholder = '没有相关数据'
      }
      this.showLoading = false
    },
    switchTab(categoryId) {
      this.$router.replace({
        name: 'custom-list',
        query: {
          categoryId,
        },
      })
      this.showFilter = (categoryId === this.categories[0].categoryId)
      this.current = categoryId
      const isFilterInfoCategory = this.filterInfo.categories.some(data => data.id === categoryId)
      const customType = (this.showFilter || isFilterInfoCategory) ? 0 : 1
      this.routeList.length = 0
      this.showLoading = true
      this.fetchCustomRouteList({
        categoryId,
        customType,
      }).then(this.isEmpty)
      this.showFilterOption = false
      this.selected = {
        time: {},
        category: {},
        city: {},
      }
      this.filter = {
        time: null,
        categoryId: null,
        cityId: null,
      }
      if (this.showFilter) {
        this.getCustomFilterInfo(this.filter)
      }
    },
    getCustomFilterInfo(filter) {
      const request = {
        beginDate: '',
        endDate: '',
      }

      if (filter.cityId) {
        request.cityId = parseInt(filter.cityId, 10)
      }

      if (filter.categoryId) {
        request.categoryId = parseInt(filter.categoryId, 10)
      }

      if (filter.time) {
        [request.beginDate, request.endDate] = filter.time.split('|', 2)
      }

      this.fetchCustomFilterInfo(filter)
    },
    onFilterClose() {
      if (this.showFilterOption) {
        this.showFilterOption = false
      }
    },
    handleFilterChanged() {
      this.getCustomFilterInfo(this.filter)
      this.routeList.length = 0
      this.showLoading = true
      this.fetchCustomRouteList({
        categoryId: this.current,
        opts: this.filter,
      }).then(this.isEmpty)
    },
    toggleFilterOption(opts, type) {
      if (this.showFilterOption && this.selectedType === type) {
        this.showFilterOption = false
        return
      }
      this.options = opts
      this.showFilterOption = true
      this.selectedType = type
      if (this.selectedType === 'category') {
        this.selectedOption = this.selected.category
        this.optionType = 'multi'
      } else if (this.selectedType === 'city') {
        this.selectedOption = this.selected.city
        this.optionType = 'multi'
      } else if (this.selectedType === 'time') {
        this.optionType = 'single'
        this.selectedOption = this.selected.time
      }
    },
    handleOptionChanged(option, show) {
      this.showFilterOption = show
      this.selectedOption = option
      if (this.selectedType === 'category') {
        this.selected.category = option
        this.selected.city = {}
        this.selected.time = {}
        this.filter.categoryId = option.id
        this.filter.cityId = null
        this.filter.time = null
      } else if (this.selectedType === 'city') {
        this.selected.city = option
        this.filter.cityId = option.id
      } else if (this.selectedType === 'time') {
        this.selected.time = option
        if (option.start) {
          this.filter.time = `${option.start}|${option.end}`
        } else {
          this.filter.time = ''
        }
      }
      this.handleFilterChanged()
    },
  },
  created() {
    meiqia.init('custom-edit')
    this.fetchCustomRouteCategoryList().then(() => {
      const { categoryId } = this.$route.query

      this.$nextTick(() => {
        // 待Dom渲染更新后再取offsetHeight
        const tab = document.querySelector('.custom-list-wrapper .yoyo-tab')
        if (tab) {
          this.offset = tab.offsetHeight + 44
        }
      })

      this.fetchCustomFilterInfo({
        time: null,
        categoryId: null,
        cityId: null,
      }).then((data) => {
        this.routeCategories = data.categories
        if (categoryId) {
          this.current = +categoryId
          this.switchTab(this.current)
        } else {
          this.switchTab(this.categories[0].categoryId)
        }
      })
    })
  },
}



// WEBPACK FOOTER //
// ./client/components/Custom/CustomList.vue